module.exports = __webpack_public_path__ + "img/active-a.3be65833.png";